var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconComment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.434,
    height: 35.025,
    viewBox: "0 0 45.434 35.025",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ikon_Kommentar",
    transform: "translate(0.225 -3.539)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39324",
    "data-name": "Path 39324",
    d: "M12.371,38.449a.606.606,0,0,1-.268,0,.7.7,0,0,1-.437-.648V29.226a12.814,12.814,0,0,1,1.2-25.585H32.3a12.821,12.821,0,0,1-.014,25.642H21.9l-9.04,8.956A.662.662,0,0,1,12.371,38.449Zm.493-33.4A11.408,11.408,0,1,0,12.4,27.86a.7.7,0,0,1,.676.7v7.491l8.1-7.97a.662.662,0,0,1,.493-.211H32.3a11.42,11.42,0,1,0,0-22.826Z",
    transform: "translate(0)",
    fill: "#fff400",
    stroke: "#fff400",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39325",
    "data-name": "Path 39325",
    d: "M9.534,18.047a3.774,3.774,0,1,1,3.774-3.774A3.774,3.774,0,0,1,9.534,18.047Zm0-6.139A2.366,2.366,0,1,0,11.9,14.274,2.366,2.366,0,0,0,9.534,11.908Z",
    transform: "translate(2.4 2.8)",
    fill: "#fff400",
    stroke: "#fff400",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39326",
    "data-name": "Path 39326",
    d: "M17.144,18.047a3.774,3.774,0,1,1,3.774-3.774,3.774,3.774,0,0,1-3.774,3.774Zm0-6.139a2.366,2.366,0,1,0,2.366,2.366A2.366,2.366,0,0,0,17.144,11.908Z",
    transform: "translate(5.506 2.8)",
    fill: "#fff400",
    stroke: "#fff400",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39327",
    "data-name": "Path 39327",
    d: "M24.74,18.047a3.774,3.774,0,1,1,3.788-3.774A3.774,3.774,0,0,1,24.74,18.047Zm0-6.139a2.366,2.366,0,1,0,1.682.688A2.366,2.366,0,0,0,24.74,11.908Z",
    transform: "translate(8.612 2.8)",
    fill: "#fff400",
    stroke: "#fff400",
    strokeWidth: 0.2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconComment);
export default __webpack_public_path__ + "static/media/Icon_comment.307ac1f839229a2daaaa551305744cf6.svg";
export { ForwardRef as ReactComponent };